import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "vant";

axios.defaults.withCredentials = true;
const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  }); 
};

let baseURL;
if (process.env.NODE_ENV !== "production") {
  baseURL = "/vue/illness";
} else {
  baseURL = 'https://zsrbactivity.zsnews.cn/';
}
console.log(baseURL);

export default createStore({
  state: { 
    envData: [],
    positiveNum: 0,
    expire:""
  },
  mutations: {
    updateEnvData(state, envData) {
      state.envData = envData;
    },
    updatePositive(state, data) {
      state.positiveNum = data.positive;
      state.expire = data.expire;
    },
  },
  actions: {
    //基础信息
    getAppEnv({ commit }) {
      axios
        // .get(baseURL + "/api/illness/index")
        .get("https://zsrbactivity.zsnews.cn/api/illness/index")
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              commit("updateEnvData", data.data);
            } else {
              tip(data.msg);
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          tip("网络错误，请重试");
        });
    },
    getPositive({ commit }) {
      axios
        .get("https://zsrbactivity.zsnews.cn/api/illness/positive")
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              commit("updatePositive", data.data);
            } else {
              tip(data.msg);
            }
          } else {
            tip("网络错误，请重试");
          }
        })
        .catch(() => {
          // tip("网络错误，请重试");
        });
    },
  },
  modules: {},
});
